import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseSlotComponent } from '../base-slot.component';
import { DateRangeWithTimeExtra } from '../../filter-drawer.types';
import { DateRangePickerComponent } from '../../../date-range-picker/date-range-picker.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { TranslocoPipe } from '@ngneat/transloco';
import dayjs from 'dayjs';

@Component({
    selector: 'date-range-with-time-slot',
    templateUrl: './date-range-with-time-slot.component.html',
    standalone: true,
    imports: [
        DateRangePickerComponent,
        ReactiveFormsModule,
        TranslocoPipe,
        NgxMaterialTimepickerModule,
    ],
})
export class DateRangeWithTimeSlotComponent extends BaseSlotComponent implements OnInit {
    @Input() formGroup!: FormGroup;
    startField!: string;
    endField!: string;
    startTimeField!: string;
    endTimeField!: string;

    ngOnInit(): void {
        super.ngOnInit();
        this.initializeDateTimeRangeSlot();
        this.addDefaultValues();
    }

    private initializeDateTimeRangeSlot(): void {
        const extra = this.slot.extra as DateRangeWithTimeExtra;
        if (extra) {
            this.startField = extra.startField;
            this.endField = extra.endField;
            this.startTimeField = extra.startTimeField;
            this.endTimeField = extra.endTimeField;
        }
    }

    private addDefaultValues(): void {
        const fromDate = this.formGroup.get(this.startField)?.value;
        const toDate = this.formGroup.get(this.endField)?.value;

        if (!fromDate) {
            const defaultFromDate = dayjs()
                .subtract(7, 'day')
                .format('YYYY-MM-DD');
            this.formGroup.get(this.startField)?.setValue(defaultFromDate, { emitEvent: false });
        }

        if (!toDate) {
            const defaultToDate = dayjs()
                .format('YYYY-MM-DD');
            this.formGroup.get(this.endField)?.setValue(defaultToDate, { emitEvent: false });
        }

        const timeFrom = this.formGroup.get(this.startTimeField)?.value;
        const timeTo = this.formGroup.get(this.endTimeField)?.value;

        if (!timeFrom) {
            this.formGroup.get(this.startTimeField)?.setValue('00:00:00', { emitEvent: false });
        }

        if (!timeTo) {
            this.formGroup.get(this.endTimeField)?.setValue('23:59:00', { emitEvent: false });
        }
    }

    getStartValue(): Date | null {
        const startValue = this.formGroup.get(this.startField)?.value;
        return startValue ? dayjs(startValue).toDate() : null;
    }

    getEndValue(): Date | null {
        const endValue = this.formGroup.get(this.endField)?.value;
        return endValue ? dayjs(endValue).toDate() : null;
    }

    onStartDateChange(date: Date | null): void {
        if (date) {
            const formattedDate = dayjs(date).format('YYYY-MM-DD');
            this.formGroup.get(this.startField)?.setValue(formattedDate, { emitEvent: false });
        } else {
            this.formGroup.get(this.startField)?.setValue(null, { emitEvent: false });
        }
    }

    onEndDateChange(date: Date | null): void {
        if (date) {
            const formattedDate = dayjs(date).format('YYYY-MM-DD');
            this.formGroup.get(this.endField)?.setValue(formattedDate, { emitEvent: false });
        } else {
            this.formGroup.get(this.endField)?.setValue(null, { emitEvent: false });
        }
    }
}
